import { render, staticRenderFns } from "./DefaultFieldBox.vue?vue&type=template&id=4a15c5e6&scoped=true"
import script from "./DefaultFieldBox.vue?vue&type=script&lang=js"
export * from "./DefaultFieldBox.vue?vue&type=script&lang=js"
import style0 from "./DefaultFieldBox.vue?vue&type=style&index=0&id=4a15c5e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a15c5e6",
  null
  
)

export default component.exports